document.addEventListener('DOMContentLoaded', function() {
    if (window.innerWidth < 1100) {  
        //variables
        let title_menu = document.querySelectorAll('.container-menus .container-menu .moret');

        // recorre todo title_menu y agrega el evento click busca a su hermano calcula la altura y lo muestra, si ya esta abierto lo cierra. tambien le añades una clase active al padre
        title_menu.forEach(function(item) {
            item.addEventListener('click', function() {
                let parent = this.parentElement;
                let submenu = this.nextElementSibling;
                let altura = submenu.scrollHeight;
                let parent_active = parent.classList.contains('active');

                if (parent_active) {
                    parent.classList.remove('active');
                    submenu.style.height = 0;
                } else {
                    parent.classList.add('active');
                    submenu.style.height = altura + 'px';
                }
            });
        });
    }  
});